import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
export default store => ({
  path: "eeSubjects",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-academicSetup" */ "./components"),
        import(
          /* webpackChunkName: "admin-academicSetup" */ "Administrator/modules/AdministratorModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const administratorReducer = importedModule1.default;
        injectReducer(store, {
          key: "administrator",
          reducer: administratorReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
});
